import React from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useAuth } from '../../components/auth/useAuth'
import { Link } from 'react-router-dom'

export default function Dashboard() { 
  	const { t } = useTranslation()
	const {clientauth} = useAuth()

	return (
        <Container className='my-3 p-5'>
            <Row>
                <Col>
                    <h1>{clientauth?.username}, {t('admin.dashboard.welcome')}</h1>
                </Col>
            </Row>
            <Row className='mt-5'>
                <Col>
                    <Link to="/admin/workorders">
                        <Card>
                            <Card.Body className='py-5 text-center'>
                                <i className='fas fa-tools fa-3x'></i>
                                <h3>{t('admin.dashboard.workOrders')}</h3>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col>
                    <Link to="/admin/clients">
                        <Card>
                            <Card.Body className='py-5 text-center'>
                                <i className='fas fa-users fa-3x'></i>
                                <h3>{t('admin.dashboard.clients')}</h3>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col>
                    <Link to="/admin/analisystypes">
                        <Card>
                            <Card.Body className='py-5 text-center'>
                                <i className='fas fa-flask-vial fa-3x'></i>
                                <h3>{t('admin.dashboard.analisysTypes')}</h3>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col>
                    <Link to="/admin/parameters">
                        <Card>
                            <Card.Body className='py-5 text-center'>
                                <i className='fas fa-vial fa-3x'></i>
                                <h3>{t('admin.dashboard.parameters')}</h3>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
        </Container>
	)
}